import React from 'react'
import { NavLink } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import {
  CContainer,
  CHeader,
  CHeaderBrand,
  CHeaderDivider,
  CHeaderNav,
  CHeaderToggler,
  CNavLink,
  CNavItem,
} from '@coreui/react'
import CIcon from '@coreui/icons-react'
import LoginButton from './LoginButton' // Adjust the path as necessary
import LogoutButton from './LogoutButton' // Adjust the path as necessary
import TextResizeButton from './TextResizeButton' // Import the new component
import { cilBell, cilEnvelopeOpen, cilList, cilMenu } from '@coreui/icons'
import { AppBreadcrumb } from './index'
import { AppHeaderDropdown } from './header/index'
import { logo } from 'src/assets/brand/logo'
import { useAuth0 } from '@auth0/auth0-react'
import feralogo from 'src/assets/xnabrand/feracloud_logo.png'

//Auth0

const AppHeader = () => {
  const dispatch = useDispatch()
  const sidebarShow = useSelector((state) => state.sidebarShow)
  const { isAuthenticated, user, isLoading, error } = useAuth0()

  return (
    <CHeader position="sticky" className="mb-4">
      <CContainer fluid>
        <CHeaderBrand className="mx-auto d-md-none" to="/">
          {/*} {<CIcon icon={logo} height={48} alt="Logo" />}*/}
        </CHeaderBrand>
        <CHeaderNav className="d-none d-md-flex me-auto">
          {/* Text resize button - positioned on the left */}
          <CNavItem>
            <TextResizeButton />
          </CNavItem>
        </CHeaderNav>
        <CHeaderNav>
          {/* -------- Authentication check block */}
          {isAuthenticated ? (
            <CNavItem>
              <div>
                {/* Display user information or authenticated user content */}
                <CNavLink href="#" style={{ color: 'gray' }}>
                  Logged in as: {user.name}
                  <LogoutButton />
                </CNavLink>
              </div>
            </CNavItem>
          ) : (
            <CNavItem>
              <div>
                <CNavLink>
                  {/* Display content for unauthenticated users */}
                  <LoginButton />
                </CNavLink>
              </div>
            </CNavItem>
          )}{' '}
          {/* -------- Authentication en */}
        </CHeaderNav>
        <CHeaderNav className="ms-3">
          <img href="/upload" className="sidebar-brand-full" src={feralogo} height={30} />
        </CHeaderNav>
      </CContainer>
    </CHeader>
  )
}

export default AppHeader
